import {Type} from 'main.core';

export class Basket
{
	constructor(options = {name: 'Basket'})
	{
		this.name = options.name;
		this.initEventListener()
	}

	initEventListener()
	{
		$('.add_to_basket').on('click', function() {
			let id = $(this).data('id');
			let quantity = $(this).data('quantity');
			let url = '/local/ajax/api/v1/basket.php?id='+id+'&quantity='+quantity;
			$.get(url, function(data) {
				// модальное окно после добавления
				$.fancybox.open($('#basket-add-msg'));
				// событие обновления корзины в шапке
				BX.onCustomEvent('OnBasketChange');

				ym(5592460,'reachGoal','nazal-knopku-dobavit-v-korziny')
			});
			return false;
		});

		$('body').on('click', '.cart-item__remove', function() {
			let id = $(this).data('id');
			let url = '/local/ajax/api/v1/basket_item_delete.php?id='+id;
			$.get(url, function(data) {
				$('.cart-item[data-item-id="'+id+'"]').remove();
			});
			return false;
		});
	}

	setName(name)
	{
		if (Type.isString(name))
		{
			this.name = name;
		}
	}

	getName()
	{
		return this.name;
	}

}